import { TileImage, TileOverlay } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { PricingText } from 'components/PricingText'
import { Cta } from 'pages/categories/CategoryPage/components/Hero/Cta'
import styles from 'pages/categories/CategoryPage/components/Hero/Hero.module.scss'
import { BACKGROUND_IMAGES_CATEGORIES } from 'pages/categories/CategoryPage/components/Hero/backgroundImages'
import { useDynamicCategoryHeadlines } from 'pages/categories/CategoryPage/components/Hero/useDynamicCategoryHeadlines'
import { usePageData } from 'pages/categories/CategoryPage/components/PageDataProvider'

export const CategoryHeroMobile = () => {
  const { slug, category } = usePageData()
  const { t } = useTranslation('@mc/next')
  const { headline, subheadline } = useDynamicCategoryHeadlines()

  if (category === null) {
    reportError('Category not found in CategoryHeroMobile')
    return null
  }

  return (
    <div className='d-block d-md-none'>
      <div
        className='position-relative d-flex justify-content-center align-items-start mc-mt-3'
        role='group'
        aria-label={t('categories.categoryPage.hero.a11y.someInstructors', {
          categoryName: category?.name,
        })}
      >
        <TileOverlay color='0,0,0' />
        <div className='mc-mr-2 mc-mt-10'>
          <TileImage
            image={
              <Image
                src={BACKGROUND_IMAGES_CATEGORIES[slug].img1}
                alt={BACKGROUND_IMAGES_CATEGORIES[slug].img1Alt}
                width={180}
                height={268}
              />
            }
            className='mc-corners--2'
          />
        </div>
        <TileImage
          image={
            <Image
              src={BACKGROUND_IMAGES_CATEGORIES[slug].img2}
              alt={BACKGROUND_IMAGES_CATEGORIES[slug].img2Alt}
              width={180}
              height={268}
            />
          }
          className='mc-corners--2'
        />
      </div>

      <div
        className={`${styles.headline} ${styles.headlineMobileVariant} row position-relative justify-content-center mc-text--center`}
      >
        <div className='col-12'>
          <h1 className='row mc-text-d3 mc-text--brand mc-text--uppercase mc-text--center mc-mb-3'>
            <div className='col-12'>{headline}</div>
          </h1>
          <h2 className='row mc-text-h3 mc-text--center mc-my-5 mc-mb-6'>
            <div className='col-12'>{subheadline}</div>
          </h2>
        </div>
      </div>
      <div className='row justify-content-center mc-text--center align-items-start'>
        <div className='col-12' style={{ maxWidth: '400px' }}>
          <div className='mc-mb-4'>
            <Cta slug={slug} />
          </div>
        </div>
        <div className='col-9 mc-mt-1'>
          <p className='mc-text-small'>
            <PricingText translationKey='long' className='mc-opacity--hinted' />
          </p>
        </div>
      </div>
    </div>
  )
}
